export const tinyMCEEditorAPIKey = "srmcevs4cz5rfqckswj3zao9ah7126jrkdc35rtsqixt93lb";